import type { KeywordSearchResponse } from '../models/ApiModels';
import type { CmsContent, CmsSearchResponse, SearchState } from '../models/SearchModels';
import { fetchJson } from './http';

const API_BASE = '/desktopmodules/Cengage_SearchEngine/API/SearchService';

function queryString(values: Record<string, string | number>): string {
  const query = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => query.set(key, String(value)));
  return query.toString();
}

export function searchProducts(state: SearchState, signal: AbortSignal): Promise<KeywordSearchResponse> {
  return fetchJson(`${API_BASE}/KeyWordSearch?${queryString({
    Division: state.division,
    PageNumber: state.page,
    Searchtext: state.query,
    SortOrder: state.sortOrder,
    Facet: state.facetSelected,
    DisciplineType: state.disciplineType,
    DisciplineCategorySk: state.categorySk,
    DisciplineSk: state.disciplineSk,
    SubjectSk: state.seriesSk,
    OptionFacet: state.showFacet
  })}`, { signal, headers: { 'Content-Type': 'application/json' } });
}

export function searchCms(state: SearchState, signal: AbortSignal): Promise<CmsSearchResponse> {
  return fetchJson(`${API_BASE}/CMSSearch?${queryString({
    Division: state.division,
    PageNumber: state.page,
    Searchtext: state.query
  })}`, { signal, headers: { 'Content-Type': 'application/json' } });
}

export function getCmsContent(state: SearchState, signal: AbortSignal): Promise<CmsContent> {
  return fetchJson(`${API_BASE}/GetCMSContentForSearch?${queryString({
    Division: state.division,
    Searchtext: state.query,
    Facet: state.facetSelected,
    DisciplineCategorySk: state.categorySk,
    DisciplineSk: state.disciplineSk,
    SubjectSk: state.seriesSk
  })}`, { signal, headers: { 'Content-Type': 'application/json' } });
}
